import { createFileRoute } from '@tanstack/react-router';
import { FinanceTransfersScreen } from '../../screens/finance/Transfers';

export const Route = createFileRoute('/finance/transfers')({
  component: FinanceTransfersScreen,
});
